import Navbar from "../../commonComponent/navbar/Navbar";
import Couverture from "./couverture/Couverture";
import AboutUs from "./aboutUs/AboutUs";
import Tapas from "./tapas/Tapas";
import Diapo from "./diapo/Diapo";
import HoraireContact from "./horaireContact/HoraireContact";
import InfoPractice from "./infoPractice/InfoPractice";
import NewsletterReserve from "./newsletterReserve/NewsletterReserve";
import Footer from "../../commonComponent/footer/Footer";
import CardSection from "./cardSection/CardSection";
import {diapoImages} from '../../assets/imageAssets';

const HomePage = () => {

    return (
    <div className="site-home">
        <Navbar />
        <main id="contenu">
        <Couverture />
        <AboutUs />
        <Tapas />
        <CardSection />
        <HoraireContact/>
        <Diapo images={diapoImages}/>
        <InfoPractice />
        <NewsletterReserve />
        </main>
        <Footer />
    </div>
    );
};

export default HomePage;
